export {
  BrandPage as default,
  getCheryStaticProps as getStaticProps,
} from '@cinch-nx/landing-feature-brand-page'
